"use strict";

var React = require('react/addons'),
    Widget = require('../partials/widget/Widget'),
    WidgetModel = require('../models/Widget'),
    DevelopersCollection = require('../collections/Developers'),
    ProjectsCollection = require('../collections/Projects'),
    BuilderGallery = require('../partials/builder/BuilderGallery'),
    BuilderOrderBy = require('../partials/builder/OrderBy'),
    RB = require('react-bootstrap');

var App = React.createClass({displayName: "App",

    getInitialState: function() {
        return {
            activeTab: 'communities',
            buildersInitialized: false,
            communitiesInitialized: true,
            showTabs: this.isAutoWidget()
        }
    },

    getDefaultProps: function() {
        var props = {
            widgetModel: new WidgetModel(),
            builderWidgetModel: new WidgetModel()
        };

        props.builderWidgetModel.listingsCollection = new DevelopersCollection();
        props.mapCollection = new ProjectsCollection();

        return props;
    },

    render: function() {
        var me = this,
            state = me.state,
            props = me.props;

        return (
            React.createElement("div", {className: "wrapper agent-shield-widget"}, 
                React.createElement("div", null, 
                    state.showTabs && (
                        React.createElement(RB.Row, null, 
                            React.createElement(RB.Nav, {bsStyle: "tabs", className: "widget-tabs", activeKey: state.activeTab, onSelect: me.handleSelect}, 
                                React.createElement(RB.NavItem, {eventKey: "communities"}, "View Communities"), 
                                React.createElement(RB.NavItem, {eventKey: "builders"}, "View Builders")
                            )
                        )
                    ), 
                    (state.activeTab === 'communities' || state.communitiesInitialized) && (
                        React.createElement(Widget, React.__spread({standalone: true},  this.props, {builder: state.builder, totalSuffixText: "Communities", className: state.showTabs ? 'widget-with-tabs' : '', model: props.widgetModel, showOrderBy: true, style: { display: state.activeTab === 'communities' ? 'block' : 'none'}}))
                    ), 
                    (state.activeTab === 'builders' || state.buildersInitialized)  && (
                        React.createElement(Widget, React.__spread({standalone: true},  this.props, {onViewBuilderCommunities: me.viewBuilderCommunities, hideMap: true, totalSuffixText: "Builders", orderBy: BuilderOrderBy, className: state.showTabs ? 'widget-with-tabs' : '', format: "builder-gallery", gallery: BuilderGallery, showBuilders: true, showOrderBy: true, model: props.builderWidgetModel, style: { display: state.activeTab === 'builders' ? 'block' : 'none'}, detailFormat: "builder-image-gallery"}))
                    )
                )
            )
        );
    },

    handleSelect: function(tabKey) {
        var me = this,
            newState = {
                activeTab: tabKey
            };

        newState[tabKey === 'communities' ? 'communitiesInitialized' : 'buildersInitialized'] = true;
        newState['builder'] = tabKey === 'communities' ? this.state.builder : undefined;

        me.setState(newState);
    },

    componentWillMount: function() {
        this.props.widgetModel.on('sync', this.onWidgetSync);
        this.props.builderWidgetModel.on('sync', this.onWidgetSync);
    },

    componentWillUnmount: function() {
        this.props.widgetModel.off('sync', this.onWidgetSync);
        this.props.builderWidgetModel.off('sync', this.onWidgetSync);
    },

    onWidgetSync: function() {
        if(this.isAutoWidget()) {
            this.setState({
                showTabs: true
            });
        }
    },

    isAutoWidget: function() {
        var widgetType = this.props.widgetModel.get('widgetType');
        return this.props.widgetModel.isLoaded() && widgetType && widgetType.id === 7;
    },

    viewBuilderCommunities: function(builder) {
        var state = {
            activeTab: 'communities',
            communitiesInitialized: true,
            builder: builder
        };

        this.setState(state);
    }
});

module.exports = App;
